/**
 * Route guard för temporär Old Booking-modul (utan RBAC).
 * Tillåter is_global_admin eller ADMIN inom Region Skåne.
 */

import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/store/authStore';
import { ROUTES } from '@/constants/routes';
import { oldBookingApi } from '@/services/booking/oldBookingApi';
import { isGlobalAdminUser } from '@/utils/isGlobalAdminUser';

interface OldBookingRouteProps {
  children: React.ReactNode;
}

export default function OldBookingRoute({ children }: OldBookingRouteProps) {
  const { user, isAuthenticated } = useAuth();
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setAllowed(false);
      return;
    }
    if (isGlobalAdminUser(user)) {
      setAllowed(true);
      return;
    }
    oldBookingApi
      .checkAccess()
      .then((r) => setAllowed(r.hasAccess))
      .catch(() => setAllowed(false));
  }, [isAuthenticated, user?.id, user?.is_global_admin]);

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (isGlobalAdminUser(user)) {
    return <>{children}</>;
  }

  if (allowed === null) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bgPrimary" />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
